var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tag',{attrs:{"color":_vm.colors[_vm.value] || _vm.colors.default,"text":_vm.$t(`article.states.${_vm.value}`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }